
import React ,{ Component } from 'react';
import {Container, Row, Col,Image,Button,Form,InputGroup,OverlayTrigger,Tooltip  } from 'react-bootstrap';
import { getAPICallData } from '../../services/MemberService';
import "../VotersModification/VotersModification.css";
import { withRouter,Link } from "react-router-dom";
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import jwt_decode from "jwt-decode";
import CardLessDataTableWithSearchLimit10 from '../datatables/CardLessDataTableWithSearchLimit10';
import loader from '../../images/loader.gif';
import { scroller } from "react-scroll";
import UpdateVoterModificationAD2024JAN from './UpdateVoterModificationAD2024JAN';
import CardLessDataTableSearchFilterLimit10 from '../datatables/CardLessDataTableSearchFilterLimit10';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };

class VotersModificationSectionAD2024JAN extends Component {
    constructor(props) {
        super(props)
        this.state = {
            chatID: window.User !=undefined ? window.User.chatID : "943827154",
            userAccessListArr:props?.location?.params?.userAccessList == undefined ? "" : props?.location?.params?.userAccessList,
            boothIdsList:[],
            boothId:"0",
            boothNo:"",
            boothIdValue:{value: "All",label: "All"},
            votersUpdatesArr:[],
            votersUpdateCheck:0,
            VMDetailsInABoothArr:[],
            VMDetailsInABoothCheck:0,
            VMTableHeading:"",
            VMDetailsBlockShow:false,

            VMVoterId:"",
            VMSerialNo:"",
            VMVoterName:"",
            VMMobileNo:"",
            VMVoterModificationId:"",
            isUpdated:"",
            VMStatusId:"",

            ValidateVMVoterName:"",
            ValidateVMParty:"",
            ValidateVMMobileNo:"",
            ValidateVMReason:"",

            party_ids_Arr:[{'value':872,'label':'TDP'},{'value':1117,'label':'YSRC'},{'value':1892,'label':'JSP'},{'value':1887,'label':'Others'}],
            partyIdStr:"",
            partyIdStrValue:"",

            caste_ids_Arr:[{'value':228, 'label':'Aandh '},{'value':326, 'label':'AASADULA '},
                            {'value':75, 'label':'Achukuntla Vandlu '},{'value':312, 'label':'Adi Dravida '},{'value':224, 'label':'AdiAndhra '},{'value':461, 'label':'Agamudayar '},{'value':309, 'label':'Agamudi Mudaliar '},{'value':121, 'label':'Agaru '},{'value':1, 'label':'Agnikula kshathriya '},{'value':199, 'label':'Anamakh '},{'value':200, 'label':'Andhravida '},{'value':122, 'label':'Arae '},{'value':388, 'label':'Arakalies and Surabi natakalavallu '},
                            {'value':201, 'label':'Arapamala '},{'value':347, 'label':'Arava '},{'value':387, 'label':'Are Marathi '},{'value':123, 'label':'Arekatika '},
                            {'value':202, 'label':'Aremala '},{'value':177, 'label':'Arundatheeya '},{'value':329, 'label':'Arwa Mala '},{'value':76, 'label':'Arya Kshathrya '},{'value':124, 'label':'Atagara '},{'value':397, 'label':'Atirasa '},{'value':77, 'label':'Avusala '},
                            {'value':396, 'label':'Ayyaraka '},{'value':2, 'label':'Badar '},{'value':229, 'label':'Bagatha '},{'value':3, 'label':'Balasanthu '},{'value':296, 'label':'Balija '},{'value':467, 'label':'Balija Kapu '},{'value':4, 'label':'Banda '},{'value':5, 'label':'Bandara '},{'value':353, 'label':'Banjara '},{'value':230, 'label':'Barhika Duliya '},{'value':203, 'label':'Barigi '},{'value':125, 'label':'Batraju '},{'value':162, 'label':'Bavuri '},
                            {'value':120, 'label':'BC - C (Cristians) '},{'value':178, 'label':'Bedajangam '},{'value':204, 'label':'Begara '},{'value':442, 'label':'Behar '},{'value':179, 'label':'Bendla '},
                            {'value':449, 'label':'Bengali '},{'value':342, 'label':'Beri Sheety '},{'value':6, 'label':'Bestha '},{'value':391, 'label':'Bhadbhunja '},{'value':7, 'label':'Bhahurupi '},{'value':390, 'label':'Bhunjwa '},{'value':8, 'label':'Bikshaka Vruthi '},{'value':439, 'label':'Biksham Gunta '},{'value':231, 'label':'Bil '},{'value':403, 'label':'Bindla '},{'value':331, 'label':'Binedu '},{'value':416, 'label':'Bodo Gadaba '},{'value':306, 'label':'Bondili '},{'value':293, 'label':'Boya '},{'value':284, 'label':'Brahmin '},{'value':9, 'label':'Buda Bukkala '},{'value':180, 'label':'Budaga Jangam '},{'value':389, 'label':'Budubunjala '},{'value':126, 'label':'Bukka '},{'value':354, 'label':'Bukka Ayyavara '},{'value':404, 'label':'Byagara '},{'value':405, 'label':'Chachati '},{'value':444, 'label':'Chacherlu '},{'value':406, 'label':'Chalavadi '},{'value':205, 'label':'Challavadi '},{'value':181, 'label':'Chamar '},{'value':182, 'label':'Chambar '},{'value':410, 'label':'Chanchandi '},{'value':164, 'label':'Chandala '},{'value':163, 'label':'Chavati '},{'value':232, 'label':'Chenchu Varu '},{'value':233, 'label':'Chenchumuni '},{'value':127, 'label':'Chimpollu '},{'value':78, 'label':'Chithari '},
                            {'value':79, 'label':'Chithrakara '},{'value':445, 'label':'Chitti Karanam '},{'value':11, 'label':'Chopamali '},{'value':459, 'label':'Christian '},{'value':470, 'label':'Converted Harijans '},{'value':183, 'label':'Dakkal/Dakkala Varu '},{'value':355, 'label':'Damala '},{'value':165, 'label':'Dandasi '},{'value':12, 'label':'Dasari (BC-A) '},{'value':128, 'label':'Dasari (BC-D) '},{'value':234, 'label':'Deseeya kondulu '},{'value':235, 'label':'Desiya Dondulu '},{'value':80, 'label':'Devanga '},{'value':13, 'label':'Devara Vandlu '},{'value':184, 'label':'Dhor '},{'value':423, 'label':'Dhulia '},{'value':167, 'label':'DomDombara '},{'value':14, 'label':'Dommara '},{'value':236, 'label':'Dondra Kodulu '},{'value':81, 'label':'Dudekula '},{'value':82, 'label':'Ediga '},{'value':321, 'label':'EKILA '},{'value':352, 'label':'Ekiri '},{'value':15, 'label':'Ellamma Vandlu '},{'value':16, 'label':'Ellasi '},{'value':345, 'label':'Erla '},{'value':237, 'label':'Gadabalu '},{'value':415, 'label':'Gadabas '},{'value':129, 'label':'Gadava '},{'value':318, 'label':'Gajula Balija '},{'value':83, 'label':'Gamalla Kalali '},{'value':84, 'label':'Gandla '},{'value':18, 'label':'Ganga Varu '},{'value':17, 'label':'Gangaputhra '},{'value':19, 'label':'Gangireddu Varu '},{'value':340, 'label':'Ganuga Sheety '},{'value':168, 'label':'Gasi '},{'value':130, 'label':'Gavara '},{'value':407, 'label':'Ghasi '},{'value':131, 'label':'Ginghar '},{'value':85, 'label':'Giniyar '},{'value':170, 'label':'Godagali '},{'value':185, 'label':'Godari '},{'value':20, 'label':'Gondlu '},{'value':238, 'label':'Gondu '},{'value':206, 'label':'Gosam '},{'value':411, 'label':'Gosangi '},{'value':357, 'label':'Gotrala '},{'value':239, 'label':'Goud-ST '},{'value':86, 'label':'Gouda '},{'value':240, 'label':'Goudh '},{'value':87, 'label':'Goundla '},{'value':21, 'label':'Gudala '},{'value':392, 'label':'Gudia '},{'value':393, 'label':'Gudiya '},{'value':417, 'label':'Gutob Gadaba '},{'value':408, 'label':'Haddi '},
                            {'value':169, 'label':'Haddi (or) Relli chachandi '},{'value':446, 'label':'Harijans '},{'value':132, 'label':'Hatkhar '},{'value':419, 'label':'Hill Reddis '},{'value':207, 'label':'Huleya '},{'value':208, 'label':'Huleya Dasari '},{'value':186, 'label':'Jaggali '},{'value':412, 'label':'JaJnbllvulu '},{'value':332, 'label':'Jakkula '},{'value':22, 'label':'Jalari '},
                            {'value':187, 'label':'Jambavulu '},{'value':88, 'label':'Jandra '},{'value':23, 'label':'Jangam '},{'value':241, 'label':'Jathapass '},{'value':24, 'label':'Jogi '},{'value':341, 'label':'Jogula '},{'value':25, 'label':'Joshinandala Bala '},{'value':133, 'label':'Kachi '},{'value':26, 'label':'Kaikadi '},{'value':89, 'label':'Kaikala '},{'value':438, 'label':'Kaitha Lambadi(Labhana) '},
                            {'value':134, 'label':'Kakkana '},{'value':335, 'label':'Kalai Balija '},{'value':135, 'label':'Kalavanthulu Ganika '},{'value':324, 'label':'KALINGA '},{'value':440, 'label':'Kalinga Vysya '},{'value':418, 'label':'kallayi gadaba '},{'value':27, 'label':'Kalli Kapu '},{'value':290, 'label':'Kamma '},{'value':90, 'label':'Kammara (BC) '},{'value':242, 'label':'Kammara (ST) '},{'value':91, 'label':'Kamsali/Vishva Bramhana '},{'value':92, 'label':'Kanchra '},{'value':136, 'label':'Kandhra '},{'value':28, 'label':'Kanjara Battu '},{'value':288, 'label':'Kapu '},{'value':466, 'label':'Kapu Kapu '},{'value':469, 'label':'Kapu-ST '},{'value':304, 'label':'KARANAM '},{'value':323, 'label':'KARIKALABHAKTHULA '},{'value':93, 'label':'Karna Bakthulu '},{'value':322, 'label':'KARNABHAKTHULA '},{'value':358, 'label':'Kasikapadi '},{'value':94, 'label':'Kathri '},{'value':29, 'label':'Kati Papala '},{'value':243, 'label':'Katunaikan '},{'value':333, 'label':'Kavali '},{'value':431, 'label':'Kerala '},{'value':359, 'label':'Keuta '},{'value':360, 'label':'Keviti '},{'value':361, 'label':'Kevuto '},{'value':30, 'label':'Kinthala Kalinga '},{'value':31, 'label':'Kirathaka '},{'value':244, 'label':'Kodhu '},{'value':245, 'label':'Kodi '},{'value':420, 'label':'Kolam '},{'value':421, 'label':'Kolawar '},{'value':188, 'label':'Koluvula Vandlu '},{'value':32, 'label':'Kompara/Reddika '},{'value':246, 'label':'Konda Doralu '},{'value':247, 'label':'Konda Kapulu '},{'value':248, 'label':'Konda Reddlu '},{'value':250, 'label':'Kondlu '},{'value':137, 'label':'Koppula Velama '},{'value':251, 'label':'Koputiya '},{'value':252, 'label':'Koram '},{'value':33, 'label':'Korcha '},{'value':138, 'label':'Kosti '},{'value':433, 'label':'Kotiya '},{'value':253, 'label':'Kotiya Benthu '},{'value':254, 'label':'Koya '},{'value':139, 'label':'Krushna Balija '},{'value':34, 'label':'Kshathriya (BC) '},{'value':291, 'label':'Kshatriya (OC) '},{'value':255, 'label':'Kuliya '},{'value':256, 'label':'Kulwalapai '},{'value':95, 'label':'Kummara '},{'value':35, 'label':'Kunapuli '},{'value':429, 'label':'Kunkuma '},{'value':475, 'label':'Kuraba '},{'value':362, 'label':'Kurakala '},{'value':382, 'label':'Kurni '},
                            {'value':96, 'label':'Kuruma '},{'value':257, 'label':'Kuttiya Kodulu '},{'value':317, 'label':'Labbai '},{'value':97, 'label':'Laddaf '},{'value':402, 'label':'Lakkamari Kapu '},{'value':363, 'label':'Lambada '},{'value':258, 'label':'Lambadi '},{'value':313, 'label':'Lingayat '},{'value':384, 'label':'Lodh '},{'value':386, 'label':'Lodha '},{'value':385, 'label':'Lodhi '},{'value':189, 'label':'Madiga '},{'value':190, 'label':'Madiga Dasu '},{'value':209, 'label':'Madisi Kuruva/Madaari Kuruva '},{'value':210, 'label':'Mahar '},{'value':36, 'label':'Mahathar '},{'value':211, 'label':'Mala '},{'value':212, 'label':'Mala Dasari '},{'value':213, 'label':'Mala Hannai '},{'value':214, 'label':'Mala Jangam '},{'value':216, 'label':'Mala Masthi '},{'value':217, 'label':'Mala Sala '},{'value':218, 'label':'Mala sanyasi '},{'value':427, 'label':'Maladasu '},{'value':140, 'label':'Mali '},{'value':259, 'label':'Malin '},{'value':37, 'label':'Mandala (BC) '},{'value':219, 'label':'Mandala (SC) '},{'value':364, 'label':'Mandula '},{'value':191, 'label':'Mang Garodi '},{'value':192, 'label':'Manga '},{'value':260, 'label':'Manna Dora '},{'value':220, 'label':'Manne '},{'value':448, 'label':'Mannepu '},{'value':261, 'label':'Mannevaru '},{'value':315, 'label':'MARATI '},{'value':330, 'label':'MARWADI '},{'value':225, 'label':'Masthi '},{'value':193, 'label':'Masthima '},{'value':194, 'label':'Mathangi '},{'value':262, 'label':'Mathaya Vavaras (or) Kuttu Vavaras '},{'value':141, 'label':'Mathula '},{'value':305, 'label':'MAYDARA '},{'value':39, 'label':'Medari '},{'value':171, 'label':'Mehthar '},{'value':319, 'label':'Mera Darji '},{'value':226, 'label':'Mitha Iyala Varu '},{'value':195, 'label':'Mochi '},{'value':301, 'label':'Mohamad '},{'value':40, 'label':'Mondi Banda '},{'value':41, 'label':'Mondi Varu '},{'value':42, 'label':'Mondipatta '},{'value':196, 'label':'Moochi '},{'value':98, 'label':'Muchi '},{'value':460, 'label':'Mudaliar '},{'value':143, 'label':'Mudhiraj '},{'value':263, 'label':'Muka Dora '},{'value':314, 'label':'MUNDALA '},{'value':144, 'label':'Munnoor Kapu '},{'value':292, 'label':'Muslim '},{'value':145, 'label':'Mutharasi '},{'value':43, 'label':'Muthyalamma Vandlu '},{'value':428, 'label':'Myralu '},{'value':451, 'label':'N/A '},{'value':348, 'label':'Nadar '},{'value':435, 'label':'Nagaralu '},{'value':99, 'label':'Nagavaddilu '},{'value':146, 'label':'Nagavamsha '},{'value':147, 'label':'Nagavasam '},{'value':264, 'label':'Naik '},{'value':265, 'label':'Naikpoth '},{'value':100, 'label':'Nakhan '},{'value':44, 'label':'Nakkala '},{'value':349, 'label':'Nambi '},
                            {'value':45, 'label':'Nashadi '},{'value':101, 'label':'Nashni/Kurni '},{'value':307, 'label':'Natari '},{'value':426, 'label':'Nayaka '},{'value':344, 'label':'Nayani Varu '},{'value':365, 'label':'Nayanivaru '},{'value':38, 'label':'Nayee Brahmin '},{'value':47, 'label':'Nayyala '},{'value':102, 'label':'Neelikanti '},{'value':148, 'label':'Nelli '},{'value':325, 'label':'NEPALI '},{'value':48, 'label':'Nera Pravruthi Kalavaru '},{'value':49, 'label':'Nershakari '},{'value':381, 'label':'Nessi '},{'value':447, 'label':'Nethekani '},{'value':50, 'label':'Nokkara '},{'value':432, 'label':'Nooka Dora '},{'value':298, 'label':'Oreganti Reddy '},{'value':458, 'label':'OTHERS '},{'value':472, 'label':'OTHERS-BC '},{'value':471, 'label':'OTHERS-OC '},{'value':473, 'label':'OTHERS-SC '},{'value':474, 'label':'OTHERS-ST '},{'value':103, 'label':'Padmashali '},{'value':166, 'label':'Paidi/pano '},
                            {'value':424, 'label':'Paiko '},{'value':172, 'label':'Paki (or) Mothi '},{'value':366, 'label':'Pala Ekari '},{'value':367, 'label':'Palegaru '},{'value':300, 'label':'Pallepu Kapu '},{'value':310, 'label':'Palli '},{'value':343, 'label':'Palli Kapu '},{'value':346, 'label':'Palli Reddy '},{'value':51, 'label':'Pambala '},{'value':174, 'label':'Pamidi '},{'value':52, 'label':'Pamula '},{'value':227, 'label':'Panchama (or) Pariyuhi '},{'value':450, 'label':'Panda '},{'value':150, 'label':'Panjari '},{'value':53, 'label':'Pannari '},{'value':266, 'label':'Parangi Parcha '},{'value':422, 'label':'Pardhan '},{'value':54, 'label':'Parthi '},{'value':151, 'label':'Paspi '},{'value':395, 'label':'Passi '},{'value':303, 'label':'Pathan '},{'value':104, 'label':'Patkhar '},{'value':55, 'label':'Patlavu '},{'value':436, 'label':'Patnayak '},{'value':434, 'label':'Patnayak '},{'value':316, 'label':'PATRA '},{'value':299, 'label':'Pattapu '},{'value':454, 'label':'Pattusali '},{'value':56, 'label':'Peddaboya '},{'value':57, 'label':'Peddama Vandlu '},{'value':105, 'label':'Perika '},{'value':106, 'label':'Perika Balija '},{'value':107, 'label':'Pinjari/Noorbash '},{'value':59, 'label':'Piriki Muggula '},{'value':58, 'label':'Pitchiguntla '},{'value':152, 'label':'Polinati Velama '},{'value':368, 'label':'Pondara '},{'value':153, 'label':'Poosala '},{'value':369, 'label':'Poosala '},{'value':267, 'label':'Porja '},{'value':60, 'label':'Porvam Bikshaka Vruthi '},{'value':462, 'label':'Pusala '},{'value':425, 'label':'Putiya '},{'value':61, 'label':'Rajaka '},{'value':370, 'label':'Rajannala '},{'value':334, 'label':'Rajput '},{'value':289, 'label':'Raju '},{'value':268, 'label':'Rajugondu '},{'value':154, 'label':'Rangaraju/Bhavasara Kshatriya '},
                            {'value':441, 'label':'Ravula '},{'value':285, 'label':'Reddy '},{'value':269, 'label':'Reddy Dora '},{'value':465, 'label':'Reddy Kapu '},{'value':468, 'label':'Reddy Reddy '},{'value':175, 'label':'Relli '},{'value':270, 'label':'Rona Rena '},{'value':443, 'label':'Sabeerlu '},{'value':452, 'label':'Sadara '},{'value':155, 'label':'Sadushetti '},{'value':371, 'label':'Saikalgar '},{'value':108, 'label':'Sakulasali '},{'value':197, 'label':'Samagara '},{'value':372, 'label':'Samanthula '},{'value':221, 'label':'Samband '},{'value':222, 'label':'Sambas '},{'value':271, 'label':'Sandrona '},{'value':109, 'label':'Sangundam '},{'value':176, 'label':'Sapru '},{'value':272, 'label':'Sardhan '},{'value':156, 'label':'Sathani '},{'value':273, 'label':'Savaras Kapusavaras '},{'value':311, 'label':'Seervi '},{'value':110, 'label':'Settibalija '},{'value':111, 'label':'Shilpi '},{'value':373, 'label':'Siddula '},{'value':274, 'label':'Sidopaiko '},{'value':430, 'label':'Sikh '},{'value':374, 'label':'Sikligar '},{'value':383, 'label':'Silpis viswakarma '},{'value':198, 'label':'Sindollu '},{'value':351, 'label':'Singh '},{'value':401, 'label':'Sistakaranam '},{'value':398, 'label':'sondi '},{'value':375, 'label':'Sountia '},{'value':112, 'label':'Sri Sayan '},{'value':275, 'label':'Sugaleelu '},{'value':399, 'label':'sundi '},{'value':394, 'label':'Surya Balija '},{'value':339, 'label':'Suryavamsha Rajulu '},{'value':302, 'label':'Syed '},{'value':328, 'label':'Telaga '},{'value':350, 'label':'Telikula '},{'value':113, 'label':'Telugu Matlade Varu '},{'value':114, 'label':'Thalikula '},{'value':157, 'label':'Thammali '},{'value':158, 'label':'Thenugollu '},{'value':276, 'label':'Thikakariya Kodulu '},{'value':115, 'label':'Thogati Thogata '},{'value':173, 'label':'Thoti (BC) '},{'value':277, 'label':'Thoti (ST) '},{'value':159, 'label':'Thurapu Kapu/Gajula Kapu '},{'value':376, 'label':'Tolagari '},{'value':160, 'label':'Uppara/Sankara '},{'value':338, 'label':'Uppu vadde '},{'value':377, 'label':'Vadabalija '},{'value':283, 'label':'Vaddera '},{'value':62, 'label':'Vaddi '},{'value':63, 'label':'Vaddolu '},{'value':116, 'label':'Vadla '},{'value':117, 'label':'Vadra '},{'value':118, 'label':'Vadrangi '},{'value':64, 'label':'Valli '},{'value':65, 'label':'Valli Reddy '},{'value':414, 'label':'Valluvan '},{'value':278, 'label':'Valmiki '},{'value':378, 'label':'Valmiki '},{'value':66, 'label':'Valmiki Boya '},{'value':455, 'label':'Vamsharaj '},{'value':437, 'label':'Vanjari '},{'value':67, 'label':'Vanne Kapu '},{'value':68, 'label':'Vanne Reddy '},{'value':336, 'label':'Vannekapu '},{'value':308, 'label':'Vanyakulakshatriya '},{'value':400, 'label':'varala '},{'value':69, 'label':'Vatti Kothala '},{'value':70, 'label':'Vedabaliga '},
                            {'value':379, 'label':'Veerabhadreeya '},{'value':327, 'label':'Veerashaiva LingayatLingabalija '},{'value':287, 'label':'Velama '},{'value':71, 'label':'Venka Kula '},{'value':72, 'label':'Vera Musti '},{'value':73, 'label':'Vodde Yeddelu '},{'value':453, 'label':'Vokkaliga '},{'value':279, 'label':'Voriya/bentu Voriya '},{'value':380, 'label':'Vyakula '},{'value':286, 'label':'Vysya '},{'value':161, 'label':'Yadava '},{'value':337, 'label':'Yalam Reddy '},{'value':74, 'label':'Yata '},{'value':413, 'label':'Yatala '},{'value':223, 'label':'Yellimal Varu '},{'value':280, 'label':'Yenadi '},{'value':281, 'label':'Yerukala '},{'value':282, 'label':'Yoniti Kodulu'}],
            casteIdStr:"",
            casteIdStrValue:"",

            reason_ids_Arr:[{'value':7,'label':'Available'},{'value':8,'label':'Migrated Permanently'},{'value':9,'label':'Migrated Temporary'},{'value':10,'label':'Death'},{'value':11,'label':'Double Entry'},{'value':14,'label':'Genuine Delete'}],
            reasonIdStr:"",
            reasonStrValue:"",

            reason_ids_Additions_Arr:[{'value':1,'label':'Available'},{'value':2,'label':'Death'},{'value':3,'label':'Migrated Permanently'},{'value':4,'label':'Migrated Temporary'},{'value':5,'label':'Fake/Not available'}],
            reasonAddIdStr:"",
            reasonAddStrValue:"",

            updateVoterModificationModel:false,
            updateVoterModifiLoadingSymbol:"hide",
            updateVoterModifiMsg:"",
            getCurrentLocationCoordinatesForVM:{},

            deletionsBlock:true,
            additionsBlock:false,
            votersADShowBlockType:"deletions"
            
        }
        
    }

    componentDidMount() {
        let userAccessList = this.state.userAccessListArr;
        if(userAccessList != null && userAccessList.status == "Success" ){
            if(userAccessList.boothList != null && userAccessList.boothList.length>0){
                let boothListArr=[];
                const obj1 = {
                    value: "All",
                    label: "All",
                }
                boothListArr.push(obj1);
                userAccessList.boothList.map(item => {
                    const obj = {
                        value: item.id,
                        label: "Booth No -"+item.name,
                        attr_mapped:item.isMapped
                    }
                    boothListArr.push(obj);
                    
                });
                this.setState({ boothIdsList: boothListArr });
                this.getVoterModificationStatus('',"Booth");
                
            }
        }else{
            this.props.history.push({pathname:"/dashboard"});
        }
    }

    handleOnchangeInputBox = (e) => {
        console.log("handleInputChange", e.target.name, e.target.value)
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
        
      }

    handleOnchangeSelectBoxNew = (ename, evalue) =>{
        const name = ename;
        const value = evalue;
    
        if(name == "boothId"){
          this.setState({ VMDetailsInABoothCheck: 0,VMDetailsInABoothArr:[],VMTableHeading:"",VMDetailsBlockShow:false});

          let getBoothIdName = this.state.boothIdsList.find((a) => a.value == value);
            this.setState({
              boothIdValue: {
                  value: getBoothIdName.value,
                  label: getBoothIdName.label
              }
          });
    
          this.setState({ boothId: getBoothIdName.value,boothNo:"Booth "+getBoothIdName.label});
          if(value == "All"){
            this.getVoterModificationStatus('',"Booth");
          }else{
            this.getVoterModificationStatus(value,"Booth");
          }
         
        
        }else if(name == "partyIdStr"){
            let partyIdName = this.state.party_ids_Arr.find((a) => a.value == value);
            this.setState({
                partyIdStrValue: {
                  value: partyIdName.value,
                  label: partyIdName.label
              }
          });

    
          this.setState({ partyIdStr: value});
        }else if(name == "casteIdStr"){
            let casteIdName = this.state.caste_ids_Arr.find((a) => a.value == value);
            this.setState({
                casteIdStrValue: {
                  value: casteIdName.value,
                  label: casteIdName.label
              }
          });

    
          this.setState({ casteIdStr: value});
        }else if(name == "reasonIdStr"){
            let reasonIdName = this.state.reason_ids_Arr.find((a) => a.value == value);
            this.setState({
                reasonStrValue: {
                  value: reasonIdName.value,
                  label: reasonIdName.label
              }
          });

    
          this.setState({ reasonIdStr: value});
        }else if(name == "reasonAddIdStr"){
            let reasonAddIdName = this.state.reason_ids_Additions_Arr.find((a) => a.value == value);
            this.setState({
                reasonAddStrValue: {
                  value: reasonAddIdName.value,
                  label: reasonAddIdName.label
              }
          });

    
          this.setState({ reasonAddIdStr: value});
        }
    }
  
    getVoterModificationStatus = (boothId,type) => {
        this.setState({ votersUpdateCheck: 0,votersUpdatesArr:[]});
        const obj =  
            JSON.stringify({ 
            "chatId" :this.state.chatID,
            "type" : type,
            "boothId" : boothId,
            "publicationDateId":41
            }
        ); 

        getAPICallData(obj,"attributes/getVoterModificationStatus")
            .then((res) => res.json())
            .then((data) => {
                if(data !=null && data.length>0){
                    this.setState({ votersUpdateCheck: 0,votersUpdatesArr:data});
                }else{
                    this.setState({ votersUpdateCheck: 1,votersUpdatesArr:[]});
                }
            });
  }

  sortFuncSerialNo(a, b, order, dataField, rowA, rowB)  { 
    if (order == 'desc') {
        
        return parseInt(rowB.Booth)  > parseInt(rowA.Booth) ? 1 : -1;

    } else {
        return parseInt(rowA.Booth)  > parseInt(rowB.Booth) ? 1 : -1;
    }
}



votersUpdatesDisplayColumns() {

    let columns = [
        {
            dataField: "Booth",
            text: "Booth",
            sort: true,
            sortFunc: this.sortFuncSerialNo.bind(this)
            
            
        },
        {
            dataField: "Total_Voters",
            text: "Total",
            sort: true,
            
        },
        {
            dataField: "verified",
            text: "V",
            sort: true,
            formatter: this.actionsFormatterForVerifiedDeletions.bind(this),
            
        },
        {
            dataField: "verified_perc",
            text: "%",
            sort: true,
            formatter: this.actionsFormatterForVerifiedPercDeletions.bind(this),
            
        },
        {
            dataField: "Pending",
            text: "P",
            sort: true,
            formatter: this.actionsFormatterForPendingDeletions.bind(this),
            
        },
        {
            dataField: "Pending_perc",
            text: "%",
            sort: true,
            formatter: this.actionsFormatterForPendingPercDeletions.bind(this),
        },
    ];
    return columns;
}


votersAdditionsUpdatesDisplayColumns() {

    let columns = [
        {
            dataField: "Booth",
            text: "Booth",
            sort: true,
            sortFunc: this.sortFuncSerialNo.bind(this)
            
            
        },
        {
            dataField: "Total_Voters_add",
            text: "Total",
            sort: true,
            
        },
        {
            dataField: "verified_add",
            text: "V",
            sort: true,
            formatter: this.actionsFormatterForVerifiedAdditions.bind(this),
            
        },
        {
            dataField: "verified_perc_add",
            text: "%",
            sort: true,
            formatter: this.actionsFormatterForVerifiedPercAdditions.bind(this),
            
        },
        {
            dataField: "Pending_add",
            text: "P",
            sort: true,
            formatter: this.actionsFormatterForPendingAdditions.bind(this),
            
        },
        {
            dataField: "Pending_perc_add",
            text: "%",
            sort: true,
            formatter: this.actionsFormatterForPendingPercAdditions.bind(this),
        },
    ];
    return columns;
}



actionsFormatterForVerifiedDeletions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_green' style={{textAlign:"left",marginLeft:"0px"}}>
                {
                   row.verified>0 ?
                   (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold text-decoraion-underline cursor_pointer' onClick={() => this.getBoothWiseVotersUpdateDetila(row.BoothId,row.Booth,row.statusName,row.statusId,"Y")}>{row.verified}</span></span>)
                   :
                   (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >0</span></span>)
                   
                }
                
            </span>
           
         </>

        
     );
    
}


actionsFormatterForVerifiedAdditions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_green' style={{textAlign:"left",marginLeft:"0px"}}>
                {
                    row.verified_add >0 ?
                    (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold text-decoraion-underline cursor_pointer' onClick={() => this.getBoothWiseVotersUpdateDetila(row.BoothId,row.Booth,row.statusName,row.statusId,"Y")}>{row.verified_add}</span></span>)
                    :
                    (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >0</span></span>)  
                    
                }
                
            </span>
           
         </>

        
     );
    
}


actionsFormatterForVerifiedPercDeletions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_green ' style={{textAlign:"left",marginLeft:"0px"}}>
            <span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >{row.verified_perc}</span> </span>
            </span>
           
         </>

        
     );
    
}


actionsFormatterForVerifiedPercAdditions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_green ' style={{textAlign:"left",marginLeft:"0px"}}>
            <span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >{row.verified_perc_add}</span> </span>
            </span>
           
         </>

        
     );
    
}


actionsFormatterForPendingDeletions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_red ' style={{textAlign:"left",marginLeft:"0px"}}>
                {
                   row.Pending>0 ?
                   (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold text-decoraion-underline cursor_pointer' onClick={() => this.getBoothWiseVotersUpdateDetila(row.BoothId,row.Booth,row.statusName,row.statusId,"N")}>{row.Pending}</span> </span>)
                   :
                   (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >0</span> </span>)
                   
                }
            </span>
           
         </>

        
     );
    
}


actionsFormatterForPendingAdditions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_red ' style={{textAlign:"left",marginLeft:"0px"}}>
                {
                   row.Pending_add > 0 ?
                   (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold text-decoraion-underline cursor_pointer' onClick={() => this.getBoothWiseVotersUpdateDetila(row.BoothId,row.Booth,row.statusName,row.statusId,"N")}>{row.Pending_add}</span> </span>)
                   :
                   (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >0</span> </span>)
                   
                }
            </span>
           
         </>

        
     );
    
}


actionsFormatterForPendingPercDeletions = (cell, row, rowIndex, formatExtraData) => {

    return (
        <>
            <span className='f-12 color_red ' style={{textAlign:"left",marginLeft:"0px"}}>
            <span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >{row.Pending_perc}</span> </span>
            </span>
           
         </>

        
     );
    
}


actionsFormatterForPendingPercAdditions = (cell, row, rowIndex, formatExtraData) => {

    return (
        <>
            <span className='f-12 color_red ' style={{textAlign:"left",marginLeft:"0px"}}>
            <span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >{row.Pending_perc_add}</span> </span>
            </span>
           
         </>

        
     );
    
}

votersUpdatesDisplayData = (statusName,statusId) => {
    let votersData = [];
    
    if(this.state.votersUpdatesArr.length>0){
        
        for (var  i in  this.state.votersUpdatesArr) {
            if(this.state.votersUpdatesArr[i].deletedStatus.votersCnt >0){
                const locationName = (this.state.votersUpdatesArr[i].locationName);
                const locationId = (this.state.votersUpdatesArr[i].locationId);
                const deletedUpdatedCnt = (this.state.votersUpdatesArr[i].deletedStatus.updatedCnt);
                const deletedPendingCnt = (this.state.votersUpdatesArr[i].deletedStatus.pendingCnt);
                const deletedUpdatedPercentage = (this.state.votersUpdatesArr[i].deletedStatus.updatedPercentage);
                const deletedPendingPercentage = (this.state.votersUpdatesArr[i].deletedStatus.pendingPercentage);
                const votersDelCnt = (this.state.votersUpdatesArr[i].deletedStatus.votersCnt);
                
                const obj = {
                    Booth:(locationName),
                    BoothId: locationId,
                    Total_Voters:votersDelCnt,
                    verified:deletedUpdatedCnt,
                    verified_perc:deletedUpdatedPercentage,
                    Pending:deletedPendingCnt,
                    Pending_perc:deletedPendingPercentage,
                    statusName:statusName,
                    statusId:statusId
                }
                votersData.push(obj);
            }
            
        } 

        
        
        return votersData;
    }
}


votersUpdatesDisplayDataAdditions = (statusName,statusId) => {
    let votersData2 = [];
    
    if(this.state.votersUpdatesArr.length>0){
        
        for (var  i in  this.state.votersUpdatesArr) {
            if(this.state.votersUpdatesArr[i].addedStatus.votersCnt >0){
                const locationName = (this.state.votersUpdatesArr[i].locationName);
                const locationId = (this.state.votersUpdatesArr[i].locationId);
                const votersAddCnt = (this.state.votersUpdatesArr[i].addedStatus.votersCnt);
                const addedUpdatedCnt = (this.state.votersUpdatesArr[i].addedStatus.updatedCnt);
                const addedPendingCnt = (this.state.votersUpdatesArr[i].addedStatus.pendingCnt);
                const addedUpdatedPercentage = (this.state.votersUpdatesArr[i].addedStatus.updatedPercentage);
                const addedPendingPercentage = (this.state.votersUpdatesArr[i].addedStatus.pendingPercentage);
            
                
                const obj = {
                    Booth:(locationName),
                    BoothId: locationId,
                    Total_Voters_add:votersAddCnt,
                    verified_add:addedUpdatedCnt,
                    verified_perc_add:addedUpdatedPercentage,
                    Pending_add:addedPendingCnt,
                    Pending_perc_add:addedPendingPercentage,
                    statusName:statusName,
                    statusId:statusId
                }
                votersData2.push(obj);
            }
        } 

        
        
        return votersData2;
    }
}

getBoothWiseVotersUpdateDetila = (boothId,boothName,statusName,StatusId,isUpdated) => {
    scroller.scrollTo("scroll_top_VM", { 
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
    });

    this.setState({ VMDetailsInABoothCheck: 0,VMDetailsInABoothArr:[],VMTableHeading:"",VMDetailsBlockShow:true});
    
    const obj =  
            JSON.stringify({ 
            "chatId" :this.state.chatID,
            "boothId" : boothId,
            "voterStatusId" : StatusId,
            "isUpdated":isUpdated,
            "publicationDateId":41
            }
        ); 

        getAPICallData(obj,"attributes/getVMDetailsInABooth")
            .then((res) => res.json())
            .then((data) => {
                this.setState({ VMTableHeading: "Booth-"+boothName+" "+statusName+" Voter Details"});
                if(data !=null && data.length>0){
                    console.log("ddddddd",data)
                    const decodeVoterDataVM = data.map((item,index) => {
                        var voterModificationIdEncoded = (item.voterModificationId);
                        var voterId = item.voterId== "" ? "" : jwt_decode(item.voterId).sub;
                        var boothId = item.boothId== "" ? "" : jwt_decode(item.boothId).sub;
                        var booth = item.booth== "" ? "" : jwt_decode(item.booth).sub;
                        var serialNo = item.serialNo== "" ? "" : jwt_decode(item.serialNo).sub;
                        var voterCardNo = item.voterCardNo== "" ? "" : jwt_decode(item.voterCardNo).sub;
                        var voterName = item.voterName== "" ? "" : jwt_decode(item.voterName).sub;
                        var relation = item.relation== "" ? "" : jwt_decode(item.relation).sub;
                        var relativeName = item.relativeName== "" ? "" : jwt_decode(item.relativeName).sub;
                        var age = item.age== "" ? "" : jwt_decode(item.age).sub;
                        var gender = item.gender== "" ? "" : jwt_decode(item.gender).sub;
                        var houseNo = item.houseNo== "" ? "" : jwt_decode(item.houseNo).sub;
                        var statusId = item.statusId== "" ? "" : jwt_decode(item.statusId).sub;
                        var status = item.status == "" ? "" : jwt_decode(item.status).sub;
                        var reasonId = item.reasonId == "" ? "" : jwt_decode(item.reasonId).sub;
                        var reason = item.reason== "" ? "" :  jwt_decode(item.reason).sub;
                        var partyId = item.partyId== "" ? "" : jwt_decode(item.partyId).sub;
                        var party = item.party == "" ? "" : jwt_decode(item.party).sub;
                        var casteId = item.casteId== "" ? "" : jwt_decode(item.casteId).sub;
                        var caste = item.caste == "" ? "" : jwt_decode(item.caste).sub;
                        var mobileNo = item.mobileNo== "" ? "" :  jwt_decode(item.mobileNo).sub;
                        var isUpdated = jwt_decode(item.isUpdated).sub;
                        
                        return { voterModificationIdEncoded,voterId,boothId,booth,serialNo,voterCardNo,voterName,relation,
                            relativeName,age,gender,houseNo,statusId,status,reasonId,
                            reason,partyId,party,casteId,caste,mobileNo,isUpdated }
                    });

                    console.log("ddddddd",decodeVoterDataVM)

                    this.setState({ VMDetailsInABoothCheck: 0,VMDetailsInABoothArr:decodeVoterDataVM});
                }else{
                    this.setState({ VMDetailsInABoothCheck: 1,VMDetailsInABoothArr:[],VMTableHeading:""});
                }
            });
}


sortFuncSerialNoVM(a, b, order, dataField, rowA, rowB)  { 
    if (order == 'desc') {
        
        return parseInt(rowB.voterCardNo)  > parseInt(rowA.voterCardNo) ? 1 : -1;

    } else {
        return parseInt(rowA.voterCardNo)  > parseInt(rowB.voterCardNo) ? 1 : -1;
    }
}

VMDetailsDisplayColumns() {

    let columns = [
        {
            dataField: "serialNo",
            text: "SNO",
            sort: true,
            sortFunc: this.sortFuncSerialNoVM.bind(this),
            formatter: this.actionsFormatterForVMDetailsSerialNo.bind(this),
            
        },
        
        {
            dataField: "voterName",
            text: "voter Name",
            sort: true,
            formatter: this.actionsFormatterForVMDetails.bind(this),
            headerStyle: {
                width: "45%"
            }
        },
        {
            dataField: "Age",
            text: "Age",
            sort: true,
           
            
        },
        {
            dataField: "Gender",
            text: "Gen der",
            sort: true,
        },{
            dataField: "Actions",
            text: "A/c",
            formatter: this.actionsFormatterForUpdateVM.bind(this),
            
        },
    
    ];
    return columns;
}
actionsFormatterForVMDetailsSerialNo = (cell, row, rowIndex, formatExtraData) => {
    return (
       (row.voterCardNo)
       
     );
}

actionsFormatterForVMDetails = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <span style={{textAlign:"left",marginLeft:"0px"}}>{(row.voterName)} 
            <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>V - {(row.serialNo)}</span></>
            <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>HouseNo - {(row.houseNo)}</span></>
           {/* <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>R - {(row.relativeName)}</span></>
            <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>Rel - {(row.relation)}</span></>*/}

            <><br/><span className='f-10' style={{textAlign:"left",marginLeft:"0px"}}>
            P - {(row.party) != '' ? <b className='color_green'>Y</b> : <b className='color_red'>N</b>},
            C - {(row.caste) != '' ? <b className='color_green'>Y</b> : <b className='color_red'>N</b>},
            M - {(row.mobileNo) != '' ? <b className='color_green'>Y</b> : <b className='color_red'>N</b>},
            
            </span></>
            <><br/><span className='f-10' style={{textAlign:"left",marginLeft:"0px"}}>
            R - {(row.reason) != '' ?  <span className='color_green fw-bold' style={{textAlign:"left",marginLeft:"0px"}}>{row.reason}</span> : <span className='color_red fw-bold' style={{textAlign:"left",marginLeft:"0px"}}>N</span>} ,
            </span></>

            
        </span>
     );
    
}

actionsFormatterForUpdateVM = (cell, row, rowIndex, formatExtraData) => {
      

    return (
        <>
        {
            row.isUpdated == 'Y'  ?
            (
                <OverlayTrigger key={"top"} placement={"top"}
                    overlay={
                        <Tooltip id={`tooltio-Filter-vm`}>
                        <h6 className='f-14'>Update Verification Status</h6>
                        </Tooltip>
                    }
                    >
                     <span className='cursor_pointer fw-bold color_green' onClick={() => this.updateVoterModificationDts(row)}><i class="fa-solid fa-pen-to-square"></i></span>
                </OverlayTrigger>
               
            )
            :
            (
                <OverlayTrigger key={"top"} placement={"top"}
                    overlay={
                        <Tooltip id={`tooltio-Filter-vm1`}>
                        <h6 className='f-14'>Update Verification Status</h6>
                        </Tooltip>
                    }
                    >
                     <span className='cursor_pointer fw-bold color_red' onClick={() => this.updateVoterModificationDts(row)}><i class="fa-solid fa-pen-to-square"></i></span>
                </OverlayTrigger>
            )
        }
        
        </>
          
     );
}

VMDetailsDisplayData = () => {
    let votersData = [];
    if(this.state.VMDetailsInABoothArr.length>0){
        
        for (let i = 0; i < this.state.VMDetailsInABoothArr.length; i++) {

            const voterModificationIdEncoded = (this.state.VMDetailsInABoothArr[i].voterModificationIdEncoded);
            const voterId = (this.state.VMDetailsInABoothArr[i].voterId);
            const boothId = (this.state.VMDetailsInABoothArr[i].boothId);
            const booth = (this.state.VMDetailsInABoothArr[i].booth);
            const serialNo = (this.state.VMDetailsInABoothArr[i].serialNo);
            const voterCardNo = (this.state.VMDetailsInABoothArr[i].voterCardNo);
            const voterName = (this.state.VMDetailsInABoothArr[i].voterName);
            const relation = (this.state.VMDetailsInABoothArr[i].relation);
            const relativeName = (this.state.VMDetailsInABoothArr[i].relativeName);
            const age = (this.state.VMDetailsInABoothArr[i].age);
            const gender = (this.state.VMDetailsInABoothArr[i].gender);
            const houseNo = (this.state.VMDetailsInABoothArr[i].houseNo);
            const statusId = (this.state.VMDetailsInABoothArr[i].statusId);
            const status = (this.state.VMDetailsInABoothArr[i].status);
            const reasonId = (this.state.VMDetailsInABoothArr[i].reasonId);
            const reason = (this.state.VMDetailsInABoothArr[i].reason);
            const partyId = (this.state.VMDetailsInABoothArr[i].partyId);
            const party = (this.state.VMDetailsInABoothArr[i].party);
            const casteId = (this.state.VMDetailsInABoothArr[i].casteId);
            const caste = (this.state.VMDetailsInABoothArr[i].caste);
            const mobileNo = (this.state.VMDetailsInABoothArr[i].mobileNo);
            const isUpdated = (this.state.VMDetailsInABoothArr[i].isUpdated);
            
            const obj = {
                serialNo:voterCardNo,
                Booth:booth,
                voterName: voterName,
                Age: age,
                Gender: gender,
                voterCardNo:serialNo,
                voterId:voterId,
                voterModificationIdEncoded:voterModificationIdEncoded,
                boothId:boothId,
                mobileNo:mobileNo,
                isUpdated:isUpdated,
                houseNo:houseNo,
                relativeName:relativeName,
                relation:relation,
                statusId:statusId,
                status:status,
                reasonId:reasonId,
                reason:reason,
                partyId:partyId,
                party:party,
                casteId:casteId,
                caste:caste,
                Actions:"Update"
            }
            votersData.push(obj);
        } 

        
        
        return votersData;
    }
}

updateVoterModificationDts = (row) => {
    navigator.geolocation.getCurrentPosition(this.showLocationVMMappingPostions,this.ShowLocationPermissionError)
    console.log("Ssssssssssss",row)
    if(row.partyId !=""){
        let partyIdName = this.state.party_ids_Arr.find((a) => a.value == row.partyId);
            this.setState({
                partyIdStrValue: {
                value: partyIdName.value,
                label: partyIdName.label
            },partyIdStr:row.partyId
        });
    }
    if(row.casteId !=""){
        let casteIdName = this.state.caste_ids_Arr.find((a) => a.value == row.casteId);
            this.setState({
                casteIdStrValue: {
                value: casteIdName.value,
                label: casteIdName.label
            },casteIdStr:row.casteId
        });
    }

    let reasonName={};
    if(row.reasonId !=""){
        if(row.statusId == 1){
            reasonName = this.state.reason_ids_Additions_Arr.find((a) => a.value == row.reasonId);
        }else{
            reasonName = this.state.reason_ids_Arr.find((a) => a.value == row.reasonId);
        }
            this.setState({
                reasonStrValue: {
                value: reasonName.value,
                label: reasonName.label
            },reasonIdStr:row.reasonId
        });
    }

   this.setState({ VMSerialNo: row.voterCardNo,
                    VMVoterName:row.voterName,
                    VMMobileNo:row.mobileNo,
                    VMVoterModificationId:row.voterModificationIdEncoded,VMVoterId:row.voterId,isUpdated:row.isUpdated,VMStatusId:row.statusId});
   this.setState({updateVoterModificationModel:true})       
}

showLocationVMMappingPostions = (position) => {
    const getCoordinates =  
        { 
          "latitude" : position.coords.latitude,
          "longitude" : position.coords.longitude,
          "accuracy":position.coords.accuracy
        }
        
    this.setState({getCurrentLocationCoordinatesForVM:getCoordinates});
  }

  ShowLocationPermissionError = (error) => {
    switch (error.code){
        case error.PERMISSION_DENIED:
          alert("User Location Permission is Denied,Please Enable Location Services...(Path:Settings > Privacy > Location Services)");
          break;

          case error.POSITION_UNAVAILABLE:
          alert("User Postion Unavailable Denied");
          break;

          default:
            alert("An unknown error occurred")
    }
}

updateVoterModifiFields = () => {
    this.setState({ValidateVMMobileNo:"",ValidateVMReason:"",ValidateVMParty:"" });
    console.log(":this.state.reasonIdStr",this.state.reasonIdStr)
    /*if(this.state.VMMobileNo != ""){
        if(!this.state.VMMobileNo.match(/^[0-9]+$/)){
            this.setState({ValidateVMMobileNo:"Please Enter Valid Mobile No" });
            return;
            }

        if(this.state.VMMobileNo.length < 10){
            this.setState({ValidateVMMobileNo:"Please Enter Valid Mobile No" });
            return;
        }
    }*/

    if(this.state.VMStatusId == 2){
        if(this.state.reasonIdStr == '' || this.state.reasonIdStr == 0){
            this.setState({ValidateVMReason:"Please Select Reason" });
            return;
        }
    }else if(this.state.VMStatusId == 1){
        if(this.state.reasonAddIdStr == '' || this.state.reasonAddIdStr == 0){
            this.setState({ValidateVMReason:"Please Select Reason" });
            return;
        }
    }
   

    /*if(this.state.partyIdStr == '' || this.state.partyIdStr == 0){
        this.setState({ValidateVMParty:"Please Select Party" });
        return;
    }*/

    this.setState({updateVoterModifiLoadingSymbol:"show"});
        const obj =  
            JSON.stringify({ 
            "chatId" :this.state.chatID,
            "voterModificationIdStr" : this.state.VMVoterModificationId,
            "partyId" : this.state.partyIdStr,
            "reasonId" : this.state.VMStatusId == 2 ? this.state.reasonIdStr : this.state.reasonAddIdStr,
            "mobileNo" : this.state.VMMobileNo,
            "casteStateId" : this.state.casteIdStr,
            "latitude": this.state.getCurrentLocationCoordinatesForVM.latitude,
            "longitude": this.state.getCurrentLocationCoordinatesForVM.longitude,

            }); 

            getAPICallData(obj,"attributes/updateVoterModificationReason")
            .then((res) => res.json())
            .then((data) => {
              this.setState({updateVoterModifiLoadingSymbol:"hide"});  
                if(data !=null && data.status == "Success"){
                    this.setState({updateVoterModifiMsg:"Updated SuccessFully..."}); 

                    this.change_status_VM(this.state.VMDetailsInABoothArr)   

                    setTimeout(() => { 
                        this.setState({updateVoterModificationModel:false});
                        //this.getVoterModificationStatus('',"Booth");
                        //this.getVotersByBoothId();  
                        this.setState({updateVoterModifiMsg:"",VMVoterModificationId:"",VMVoterId:"",getCurrentLocationCoordinatesForVM:{}});  
                        this.setState({partyIdStr:"",reasonIdStr:"",VMMobileNo:"",casteIdStr:"",partyIdStrValue:"",casteIdStrValue:"",reasonStrValue:"",isUpdated:"",VMStatusId:""
                        });
                    }, 1500);
                }else{
                    this.setState({updateVoterModifiMsg:"Some Thing Wrong,Please Check once"});  
                   
                }
          });
}

change_status_VM = (_data) => {
    for(var key in _data){
        if(_data[key].voterId == this.state.VMVoterId){
            if(this.state.partyIdStr != ""){
                _data[key].party = this.state.partyIdStrValue.label
            }else{
                _data[key].party = ''
            }

            if(this.state.VMStatusId == 1){
                if(this.state.reasonAddIdStr != ""){
                    _data[key].reason = this.state.reasonAddStrValue.label
                }else{
                    _data[key].reason = ''
                }
            }else{
                if(this.state.reasonIdStr != ""){
                    _data[key].reason = this.state.reasonStrValue.label
                }else{
                    _data[key].reason = ''
                }
            }
            

            if(this.state.VMMobileNo != ""){
                _data[key].mobileNo = this.state.VMMobileNo
            }else{
                _data[key].mobileNo = ''
            }

            if(this.state.casteIdStr != ""){
                _data[key].caste = this.state.casteIdStrValue.label
            }else{
                _data[key].caste = ''
            }
            if(this.state.isUpdated != ""){
                _data[key].isUpdated = 'Y'
            }else{
                _data[key].isUpdated = 'N'
            }
            

        }
    }
    console.log("_data",_data) ;
    this.setState({VMDetailsInABoothArr:_data});
}


votersADBlockBlockShow = (blockType) => {
    this.setState({ votersADShowBlockType: blockType});
    this.setState({ VMDetailsInABoothCheck: 0,VMDetailsInABoothArr:[],VMTableHeading:"",VMDetailsBlockShow:false});

    if(blockType == "additions"){
      this.setState({ additionsBlock: true});
      this.setState({ deletionsBlock: false});
    }else{
      this.setState({ deletionsBlock: true});
      this.setState({ additionsBlock: false});
      
    }

  }
  
  refreshTableBlock2023JanOct = () => {
    this.getVoterModificationStatus('',"Booth");
  }
    render() {
      
        return (
            <section>
               <Container>
                    <Row>
                        <Col>
                            <h6 className='text-center fw-bold text-decoration-underline'>AD 2024 JAN Voter Verification</h6>
                            
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} className='mt-4'>
                            <div className='flex_programs_block pos_top_cls'>
                                <div className={this.state.additionsBlock == true ? "border_bottom_issues_w_in cusor_pointer" : "cusor_pointer"} onClick={() => this.votersADBlockBlockShow("additions")}><h6 className='fw-bold  text-center'><i class="fa-solid fa-user-plus"></i><span className='ms-2'>Additions</span></h6></div>
                                <div className={this.state.deletionsBlock == true ? "border_bottom_issues cusor_pointer" : "cusor_pointer"} onClick={() => this.votersADBlockBlockShow("deletions")}><h6 className='fw-bold text-center'><i class="fa-solid fa-user-minus"></i><span className='ms-2'>Deletions</span></h6></div>
                            </div>
                        </Col>
                    </Row>
                    {/*<Row>
                        <Col className='w_80'>
                            <h6 className="form-label f-14 fw-bold">Booth<span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12'>{this.state.validateboothId}</span></h6>
                                <SelectBox
                                    stateData={this.state.boothIdValue}
                                    handleChange={this.handleOnchangeSelectBoxNew}
                                    name="boothId"
                                    options={this.state.boothIdsList}
                                    placeholderName={'Select Booth'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                        </Col>
                        
                        </Row>*/}

                    {/*
                        this.state.votersADShowBlockType == "deletions" ?
                        (
                            <Row>
                                <Col>
                                    <h6 className='text-center fw-bold text-decoration-underline'>Voters Deleted From 2022 Till Date</h6>
                                    <h6 className='f-14'>
                                        <span className='color_red f-14 ms-1'>*</span> After 2023 October Drafter Publication Deleted Voters will be updated here as first priority activity
                                    </h6>
                                </Col>
                            </Row>
                        )
                        :
                        ("")
                        */}

                     
                    {
                        this.state.votersUpdatesArr.length == 0 ?
                        (
                            this.state.votersUpdateCheck == 1 ?
                            (<Col className='f-14 text-center mt-3'>No Data Available</Col>)
                            :
                            (<Col sm={12}>
                            <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                            </Col>)
                        )
                        :
                        (
                            this.state.votersUpdatesArr.length>0 ? 
                            (
                                <Row>
                                    <Col sm={12}>
                                        <div className='bg_light_blue mt-2'>
                                        <h6 className='f-12 mt-3 fw-bold'>
                                                Note : <span className='ml_5 mr_2'>V - Verified,</span>
                                                        <span className='ml_5 mr_2'>P - Pending</span>
                                                        <OverlayTrigger key={"top"} placement={"top"}
                                                            overlay={
                                                            <Tooltip id={`tooltio-Filter`}>
                                                                <h6 className='f-14'>Refresh</h6>
                                                            </Tooltip>
                                                            }
                                                        >
                                                        <i class="fa-solid fa-arrows-rotate float-end cursor_pointer f-14" onClick={() => this.refreshTableBlock2023JanOct()}></i>     
                                                        </OverlayTrigger>
                                                        
                                            </h6>
                                            {
                                                this.state.votersADShowBlockType == "deletions" ?
                                                (
                                                    <CardLessDataTableWithSearchLimit10 
                                                            parentData={this.votersUpdatesDisplayData("Deletions",2)}
                                                            particlecolumns={this.votersUpdatesDisplayColumns()}
                                                            defaultSorted={[{
                                                                dataField: "Booth",
                                                                order: "asc"
                                                            }]}
                                                        tableHeading="Booth Wise Deleted Voters Verification Status"
                                                        />
                                                )
                                                :
                                                (
                                                    <CardLessDataTableWithSearchLimit10 
                                                            parentData={this.votersUpdatesDisplayDataAdditions("Additions",1)}
                                                            particlecolumns={this.votersAdditionsUpdatesDisplayColumns()}
                                                            defaultSorted={[{
                                                                dataField: "Booth",
                                                                order: "asc"
                                                            }]}
                                                        tableHeading="Booth Wise Additions Voters Verification Status"
                                                        />
                                                )
                                            }
                                           
                                        </div>
                                    </Col>
                                </Row>
                            )
                            :
                            ("")
                        )
                        
                        }

                        <div className='scroll_top_VM'>
                            {
                            this.state.VMDetailsBlockShow == true &&  this.state.VMDetailsInABoothArr.length == 0 ?
                            (
                                this.state.VMDetailsInABoothCheck == 1 ?
                                (<Col className='f-14 text-center mt-3'>No Data Available</Col>)
                                :
                                (<Col sm={12}>
                                <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                </Col>)
                            )
                            :
                            (
                                this.state.VMDetailsInABoothArr.length>0 ? 
                                (
                                    <Row>
                                        <Col sm={12}>
                                            <div className='bg_light_blue mt-2'>
                                            <h6 className='f-12 mt-3 fw-bold'>
                                                Note : <span className='ml_5 mr_2'>P - Party,</span>
                                                        <span className='ml_5 mr_2'>C - Caste,</span>
                                                        <span className='ml_5 mr_2'>M - Mobile,</span>
                                                        <span className='ml_5 mr_2'>R - Reason</span>
                                            </h6>
                                            <h6 className='f-12 mt-2 fw-bold' style={{marginLeft:"40px"}}>
                                                        <span className='ml_5 mr_2 color_green'>Y - Updated,</span>
                                                        <span className='ml_5 mr_2 color_red'>N - Not Updated,</span>
                                                        
                                            </h6>
                                                <CardLessDataTableSearchFilterLimit10 
                                                    parentData={this.VMDetailsDisplayData()}
                                                    particlecolumns={this.VMDetailsDisplayColumns()}
                                                    defaultSorted={[{
                                                        dataField: "serialNo",
                                                        order: "asc"
                                                    }]}
                                                tableHeading={this.state.VMTableHeading}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                )
                                :
                                ("")
                            )
                            
                            }
                        </div>

                        
                <UpdateVoterModificationAD2024JAN 
                        show={this.state.updateVoterModificationModel}
                        onHide={() => this.setState({ updateVoterModificationModel: false })}
                        stateData={this.state}
                        phandleOnchangeSelectBoxNew={this.handleOnchangeSelectBoxNew}
                        phandleOnchangeInputBox={this.handleOnchangeInputBox}
                        pupdateVoterModifiFields={this.updateVoterModifiFields}
                />
               </Container>
            </section>
        )
    }
  }
  
  export default withRouter(VotersModificationSectionAD2024JAN);
  